export type RightHandSideExperiment = {
  isRHSExperiment: boolean;
  isRHSExperimentControl: boolean;
  isRHSExperimentLineItemsEnabled: boolean;
  isRHSExperimentBreakdownButtonEnabled: boolean;
};

export const checkRightHandSideExperimentEnabled = (
  growthRHSTreatmentKey: string | undefined,
  sale: any,
  isMobile: boolean = false
): RightHandSideExperiment => {
  const treatmentKeyControl = 'IXP2_T_1065834'; // Control
  const treatmentKeyLineItems = 'IXP2_T_1065835'; // lineItemsEnabled
  const treatmentKeyBreakdown = 'IXP2_T_1065836'; // breakdownButtonEnabled

  let isRHSExperimentControl = false;
  let isRHSExperimentLineItemsEnabled = false;
  let isRHSExperimentBreakdownButtonEnabled = false;
  let isValidInvoice = false;

  // Client-side check for transaction type (not available in IXP contextMap)
  const isInvoice = sale.type === 'INVOICE'; // Using string literal since TXN_MAP not imported

  // Basic eligibility (IXP handles isPayEnabled and isMaipInvoice server-side)
  isValidInvoice = isInvoice;

  if (isValidInvoice && growthRHSTreatmentKey) {
    if (growthRHSTreatmentKey === treatmentKeyControl) {
      isRHSExperimentControl = true;
    }
    if (growthRHSTreatmentKey === treatmentKeyLineItems) {
      isRHSExperimentLineItemsEnabled = true;
    }
    if (growthRHSTreatmentKey === treatmentKeyBreakdown) {
      if (isMobile) {
        // On mobile, breakdown treatment becomes line items treatment (no breakdown button on mobile)
        isRHSExperimentLineItemsEnabled = true;
      } else {
        // On desktop, use breakdown button
        isRHSExperimentBreakdownButtonEnabled = true;
      }
    }
  }

  return {
    isRHSExperiment:
      isRHSExperimentControl ||
      isRHSExperimentLineItemsEnabled ||
      isRHSExperimentBreakdownButtonEnabled,
    isRHSExperimentControl,
    isRHSExperimentLineItemsEnabled,
    isRHSExperimentBreakdownButtonEnabled,
  };
};
